import { isSetLotteryBetType } from '../../types/setLottery.types'
import type { BetDetailItem } from './TicketDetails'

/**
 * Compute the final payout for a bet detail item.
 * For set lottery: capped at maxRewardAmount.
 * For regular bets: (limitedPayoutRate ?? payoutRate) * betAmount.
 */
export function computeFinalPayout(
  item: Pick<
    BetDetailItem,
    | 'finalPayout'
    | 'payoutRate'
    | 'limitedPayoutRate'
    | 'betAmount'
    | 'maxRewardAmount'
    | 'rawBetType'
  >,
): number {
  if (item.finalPayout !== undefined) return item.finalPayout

  const rate = item.limitedPayoutRate ?? item.payoutRate
  const uncapped = rate * item.betAmount

  if (
    isSetLotteryBetType(item.rawBetType) &&
    item.maxRewardAmount !== undefined
  ) {
    return Math.min(uncapped, item.maxRewardAmount)
  }

  return uncapped
}
